'use client'
import { usePathname } from 'next/navigation'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'
import { createContext, useEffect, useState } from 'react'

type TypeSortBy = {
  name: string
  value: string
}

type TypeState = {
  filterQ: string
  sortBy: TypeSortBy
  filterBy: string
  setFilterQ: Dispatch<SetStateAction<string>>
  setSortBy: Dispatch<SetStateAction<TypeSortBy>>
  setFilterBy: Dispatch<SetStateAction<string>>
}

const initialState: TypeState = {
  filterQ: null,
  sortBy: null,
  filterBy: null,
  setFilterQ:  () => {},
  setSortBy:  () => {},
  setFilterBy:  () => {}
}

export const FiltersContext = createContext<TypeState | null>(initialState)

interface Props {
  children: ReactNode
}

export const FiltersProvider: FC<Props> = ({ children }) => {
  const [filterQ, setFilterQ] = useState<string>(undefined)
  const [sortBy, setSortBy] = useState<TypeSortBy>(undefined)
  const [filterBy, setFilterBy] = useState<string>(undefined)

  const pathname = usePathname()

  useEffect(() => {
    console.log('FiltersProvider pathname: ', pathname)
    queueMicrotask(() => setFilterQ(undefined))
    queueMicrotask(() => setFilterBy(undefined))
  }, [pathname])

  return <FiltersContext.Provider value={{
    filterQ, setFilterQ,
    sortBy, setSortBy,
    filterBy, setFilterBy
  }}>{children}</FiltersContext.Provider>
}
